import React from 'react'

const SVG = ({
  style = { position: 'absolute', fill: '#000000' },
  viewBox = '0 0 104.82 100',
  width = '104.82',
  height = '100',
  ...rest
}) => (
  <svg
    style={style}
    height={height}
    width={width}
    viewBox={viewBox}
    xmlns='http://www.w3.org/2000/svg'
    {...rest}
  >
    <path d='M11 89V16.87H0V100h89.73V89zm82.82-33.86v12.89H31.34V11h16.98V0H20.34v79.04h84.48v-23.9z' />
    <path d='M64.36 48.22l29.35-29.35V41.6l11.11-.1-.1-39.83L103.04 0H63l-.1 11 22.12-.1L56.5 39.53z' />
  </svg>
)
export default SVG
